import { Component, Inject, Input, Optional } from '@angular/core';
import { CONFIG_MODAL_INPUTS_TOKEN, ModalOverlayRef } from '@core/classes/modal-overlay.ref';

@Component({
  selector: 'mfp-insurance-reasons',
  templateUrl: './insurance-reasons.component.html',
  styleUrls: ['./insurance-reasons.component.scss']
})
export class InsuranceReasonsComponent {
  @Input() reasons = [];

  constructor(
    public dialogRef: ModalOverlayRef,
    @Optional() @Inject(CONFIG_MODAL_INPUTS_TOKEN) config: any) {
      if (config) {
        this.reasons = config.reasons;
      }
    }

  close() {
    this.dialogRef.close();
  }

}
